module.exports = __webpack_public_path__ + "static/media/Allahu-Akbar.16c314f5.jpg";